import React from 'react';
import { Link } from 'react-router-dom';
import Container from '../Container/Container';
import cvData from '../../../assets/data/cv-data';
import './Footer.css';

const Footer = () => {
  const socialLinks = [
    { label: 'GitHub', href: cvData.personalInfo.socialLinks.github },
    { label: 'LinkedIn', href: cvData.personalInfo.socialLinks.linkedin },
    { label: 'Twitter', href: cvData.personalInfo.socialLinks.twitter }
  ];

  return (
    <footer className="footer">
      <Container>
        <div className="footer-content">
          <div className="footer-section">
            <h3>My Portfolio</h3>
            <p>Personal webpage showcasing my work and skills</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/profile">Profile</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Connect</h4>
            <div className="social-links">
              {socialLinks
                .filter((link) => Boolean(link.href))
                .map((link) => (
                  <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer">
                    {link.label}
                  </a>
                ))}
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} My Portfolio. All rights reserved.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
